module.exports = __webpack_public_path__ + "img/编组 (3).90584d04.png";